export default __webpack_public_path__ + "static/media/sports-cat-cn.a4de271b.webp";